module.exports = __webpack_public_path__ + "static/media/streetsofaustralia_orenji.5496dec7.png";